var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedPlsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "22px",
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.9994V16.8327C15 18.7659 11.8663 20.3327 8 20.3327C4.13367 20.3327 1 18.7659 1 16.8327V10.9994M15 10.9994V5.16602M15 10.9994C15 12.9325 11.8663 14.4994 8 14.4994C4.13367 14.4994 1 12.9325 1 10.9994M1 10.9994V5.16602M15 5.16602C15 3.23285 11.8663 1.66602 8 1.66602C4.13367 1.66602 1 3.23285 1 5.16602M15 5.16602C15 7.09918 11.8663 8.66602 8 8.66602C4.13367 8.66602 1 7.09918 1 5.16602",
    stroke: "#4f46e5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPlsIcon);
export default __webpack_public_path__ + "static/media/selectedPLS-icon.4a228214a203ab8494c6b9d290e7a7d6.svg";
export { ForwardRef as ReactComponent };